/**
 * A global namespace for `focusout` event.
 */
const focusoutEvent = "focusout";
export default focusoutEvent;
